
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqvVQH98XbQjvdKkNFZG0rhZgEBUpzmAC_45vhmgN60u76sMeta } from "/var/www/lottobox-livedraw/pages/faq.vue?macro=true";
import { default as aboutq6Y0SAE69bFspevTVUT4VVg_qERj2mh0uIclRsUZXC4Meta } from "/var/www/lottobox-livedraw/pages/about.vue?macro=true";
import { default as indexHDQlSQraUHwv8uZf4Ho1vJOarMR1dUjwNEqVBFz3VJcMeta } from "/var/www/lottobox-livedraw/pages/index.vue?macro=true";
import { default as privacy3lA5rlNBBF4rvD6ELqRJEAH5H7ak7tK9oLacDCyDSLIMeta } from "/var/www/lottobox-livedraw/pages/privacy.vue?macro=true";
import { default as disclaimerf5sb4bzfdG_cIga1I5kU2JvhoGZE9eMS4kRB4xdf0DEMeta } from "/var/www/lottobox-livedraw/pages/disclaimer.vue?macro=true";
import { default as component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEgMeta } from "/var/www/lottobox-livedraw/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEg } from "/var/www/lottobox-livedraw/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/var/www/lottobox-livedraw/pages/faq.vue")
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/var/www/lottobox-livedraw/pages/faq.vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/var/www/lottobox-livedraw/pages/about.vue")
  },
  {
    name: "about___zh",
    path: "/zh/about",
    component: () => import("/var/www/lottobox-livedraw/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/var/www/lottobox-livedraw/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/var/www/lottobox-livedraw/pages/index.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/var/www/lottobox-livedraw/pages/privacy.vue")
  },
  {
    name: "privacy___zh",
    path: "/zh/privacy",
    component: () => import("/var/www/lottobox-livedraw/pages/privacy.vue")
  },
  {
    name: "disclaimer___en",
    path: "/disclaimer",
    component: () => import("/var/www/lottobox-livedraw/pages/disclaimer.vue")
  },
  {
    name: "disclaimer___zh",
    path: "/zh/disclaimer",
    component: () => import("/var/www/lottobox-livedraw/pages/disclaimer.vue")
  },
  {
    name: component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEg
  },
  {
    name: component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEgMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stubMMVifnKFue4e4BfOJsy90t9mmJdMQfJ2YhN3AQL7EEg
  }
]